export enum LogoutReasons {
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  USER_DATA_LOAD_FAIL = 'USER_DATA_LOAD_FAIL',
  USER_PROFILE_DELETED = 'USER_PROFILE_DELETED',
  USER_EMAIL_CHANGED = 'USER_EMAIL_CHANGED'
}
